import { render } from "./BackgroundImage.vue?vue&type=template&id=0790fab0&scoped=true"
import script from "./BackgroundImage.vue?vue&type=script&lang=js"
export * from "./BackgroundImage.vue?vue&type=script&lang=js"

import "./BackgroundImage.vue?vue&type=style&index=0&id=0790fab0&scoped=true&lang=scss"

import exportComponent from "/codebuild/output/src1149623050/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0790fab0"]])

export default __exports__